import { render, staticRenderFns } from "./DemandaList.vue?vue&type=template&id=0ea9fbbc&"
import script from "./DemandaList.vue?vue&type=script&lang=js&"
export * from "./DemandaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports